import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconEdit = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6667 5C14.9319 5 15.1862 5.10536 15.3738 5.29289L18.7071 8.62623C19.0976 9.01675 19.0976 9.64992 18.7071 10.0404L10.0404 18.7071C9.8529 18.8946 9.59855 19 9.33333 19H6C5.44772 19 5 18.5523 5 18V14.6667C5 14.4015 5.10536 14.1471 5.29289 13.9596L13.9596 5.29289C14.1471 5.10536 14.4015 5 14.6667 5ZM7 15.0809V17H8.91912L16.5858 9.33333L14.6667 7.41421L7 15.0809Z"
        />
      </svg>
    );
  }
);
